import type { I18n, MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

/**
 * Translatable names for quota packs (GET /api/billing/plan-addons options).
 *
 * The API only carries the feature catalog's `labelRo` / `labelEn`
 * (packages/feature-gating/src/catalog.ts), and `labelRo` is ASCII-only and
 * partly English ("Programari/luna", "SMS reminders"). Packs that can be sold
 * get a Lingui string here, so every locale reads its own language; any other
 * feature key falls back to the catalog's English label.
 */
const PACK_LABELS: Record<string, MessageDescriptor> = {
  "provider.bookings.per_month": msg`Bookings / month`,
  "provider.messaging.sms.per_month": msg`SMS reminders`,
  "provider.messaging.viber.per_month": msg`Viber messages`,
  "provider.messaging.whatsapp.per_month": msg`WhatsApp messages`,
  "provider.messaging.push.per_month": msg`Push notifications`,
  "provider.video.consultations.per_month": msg`Video consultations / month`,
  "facility.reminders.sms.per_month": msg`Clinic SMS reminders`,
  "facility.reminders.viber.per_month": msg`Clinic Viber reminders`,
  "facility.reminders.whatsapp.per_month": msg`Clinic WhatsApp reminders`,
  "business.messaging.sms.per_month": msg`SMS outreach`,
};

export function packLabel(i18n: I18n, pack: { featureKey: string; labelEn: string }): string {
  const descriptor = PACK_LABELS[pack.featureKey];
  return descriptor ? i18n._(descriptor) : pack.labelEn || pack.featureKey;
}
